<template>
    <div class="protocol">
      <i class="iconfont iconfanhui back" @click.stop="$router.push({path: '/ceramide'})">返回</i>
      <div class="protocol_wrap">
        <div class="protocol_box">
          <p class="title">协议与政策</p>
          <p class="content">欢迎使用心血管疾病风险评估产品及服务！为给您更好的产品使用体验以及保护您的隐私权益，在您使用该产品服务前，请认真阅读《至您的一封信》，以了解产品适用场景，用户权利义务和个人信息处理规则。阅读过程中，如您有任何疑问，请随时联系我们。</p>
          <div class="read">
            <van-checkbox v-model="checked" shape="square" icon-size="13px"></van-checkbox>
            <p>全文阅读<span @click="$router.push({path: '/protocolContent'})">《至您的一封信》</span>和<span @click="$router.push({path: '/protocolContent'})">《疾病介绍》</span></p>
          </div>
          <div class="protocol_btn" @click="goOn">
            <span>同意，继续查看报告</span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  name: 'protocol',
  data () {
    return {
      checked: false
    }
  },
  methods: {
    goOn () {
      if (this.checked) {
        this.$router.push('/health')
      } else {
        Toast('请先勾选页面中“全文阅读《至您的一封信》和《疾病介绍》”')
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .protocol {
    width: 100%;
    height: 100%;
    background: #fff;
    position: relative;

    .back {
      position: absolute;
      top: pxToRem(20px);
      left: pxToRem(20px);
      font-size: pxToRem(25px);
      color: #000;
    }

    .protocol_wrap {
      width: pxToRem(604px);
      height: pxToRem(850px);
      background: url('../../assets/images/ceramide/protocolBg.png') no-repeat center;
      background-size: cover;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      border-radius: pxToRem(10px);

      .protocol_box {
        padding: pxToRem(92px) pxToRem(56px) 0;
        margin: 0 auto;

        .title {
          font-size: pxToRem(40px);
          text-align: center;
          color: #000;
        }

        .content {
          font-size: pxToRem(22px);
          font-weight:400;
          color: #000;
          text-indent: 1em;
          line-height: 2em;
          letter-spacing: 2px;
          margin: pxToRem(54px) 0 pxToRem(50px);
        }

        .read {
          /*display: inline-block;*/
          font-size: pxToRem(20px);
          display: flex;
          justify-content: space-between;
          align-items: center;

          span {
            color: #448ACA;
          }
        }

        .protocol_btn {
          margin-top: pxToRem(85px);
          text-align: center;
          span {
            padding: pxToRem(12px) pxToRem(50px);
            background: #448ACA;
            color: #fff;
            border-radius: pxToRem(10px);
            font-size: pxToRem(28px);
            font-weight:400;
          }
        }
      }
    }
  }
</style>
<style lang="scss">
  @import "../../assets/scss/functions";
  .protocol {
    .van-checkbox {
      /*float: left;*/
      margin-right: pxToRem(10px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/ceramide/protocol.vue